class DOMIDs {
  prefix = 'rg-widget';

  createId(id) {
    return `${this.prefix}-${id}`;
  }

  get frame() {
    return this.createId('frame');
  }

  get featureIcons() {
    return this.createId('compact');
  }

  get messenger() {
    return this.createId('messenger');
  }

  get compact() {
    return this.featureIcons;
  }

  // V2 Multi-message IDs
  get compactV2() {
    return this.createId('compact-v2');
  }

  get messengerV2() {
    return this.createId('messenger-v2');
  }

  get bubbles() {
    return this.createId('bubbles');
  }

  get relativeNode() {
    return 'rg-widget-relative';
  }
}

export const rgIDs = new DOMIDs();
